import { DatePicker, DatePickerProps } from '@components/datepicker';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormDatePickerProps<T = unknown> = FormFieldProps<DatePickerProps, T>;

export function FormDatePicker<T>(props: FormDatePickerProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'date' });

  return <DatePicker {...props} {...formFieldProps} />;
}
